import { BUILDER_ESTIMATOR_STEPS_MAP } from "@/constants/builderEstimatorStepNavigationTextMap";
import { BuilderEstimatorSteps } from "@/enums/BuilderEstimatorSteps";
import { computed } from "vue";

export const useBuilderEstimatorStepIndicator = (props: {
  steps: BuilderEstimatorSteps[];
  currentStep: BuilderEstimatorSteps;
}) => {
  const isLastStep = computed(
    () => props.currentStep === props.steps[props.steps.length - 1]
  );
  const isFirstStep = computed(() => props.currentStep === props.steps[0]);
  const prevStepIndex = computed(
    () =>
      (props.steps.indexOf(props.currentStep) - 1 + props.steps.length) %
      props.steps.length
  );
  const nextStepIndex = computed(
    () => (props.steps.indexOf(props.currentStep) + 1) % props.steps.length
  );

  const nextStepTextButton = computed(
    () =>
      BUILDER_ESTIMATOR_STEPS_MAP[props.steps[nextStepIndex.value]] ?? "Next"
  );
  const backStepTextButton = computed(
    () =>
      BUILDER_ESTIMATOR_STEPS_MAP[props.steps[prevStepIndex.value]] ?? "Back"
  );

  return {
    isLastStep,
    isFirstStep,
    prevStepIndex,
    nextStepIndex,
    nextStepTextButton,
    backStepTextButton,
  };
};
